import { render, staticRenderFns } from "./HelpfulInfoArticle5.vue?vue&type=template&id=1210fc74&scoped=true"
import script from "./HelpfulInfoArticle5.vue?vue&type=script&lang=js"
export * from "./HelpfulInfoArticle5.vue?vue&type=script&lang=js"
import style0 from "./HelpfulInfoArticle5.vue?vue&type=style&index=0&id=1210fc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210fc74",
  null
  
)

export default component.exports